import styled from 'styled-components';
import { Section } from 'View/Container';

export const StyledSection3 = styled(Section)`
  .container-fluid {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
